import styled from '@emotion/styled'
import { Box } from '@mui/material'
import AutoFixHighIcon from '@mui/icons-material/AutoFixHigh'
import { typography, colors } from '@resiliatech/birdsong'

export const PageContainer = styled(Box)`
  display: flex;
  flex-direction: column;
  height: 100vh;
  width: 100%;
`

export const ContentWrapper = styled(Box)`
  display: flex;
  align-items: center;
  justify-content: center;
  flex: 1;
`

export const StepContainer = styled(Box)<{ width?: number; height?: number }>`
  display: flex;
  width: ${({ width }) => (width ? `${width}px` : '1040px')};
  height: ${({ height }) => (height ? `${height}px` : 'auto')};
  padding: 64px;
  flex-direction: column;
  align-items: flex-start;
  gap: 32px;
  flex-shrink: 0;
  border-radius: 10px;
  background: ${colors.background.secondaryBackground};
  box-shadow: 0px 14.462px 73.917px 12.855px rgba(0, 0, 0, 0.12),
    0px 38.566px 61.062px 4.821px rgba(0, 0, 0, 0.14),
    0px 17.676px 24.104px -11.248px rgba(0, 0, 0, 0.2);
  margin: 0 auto;
`

export const HeaderContainer = styled(Box)`
  display: flex;
  flex-direction: column;
  gap: 24px;
  width: 100%;
  align-items: flex-start;
`

export const Header = styled(Box)`
  display: flex;
  flex-direction: column;
`

export const HeaderTitleContainer = styled(Box)`
  display: flex;
  gap: 16px;
  width: 100%;
  align-items: center;
  justify-content: flex-start;
`

export const HeaderTitle = styled.h4`
  ${typography.up2.regularSans};
  line-height: 28px;
  color: #000;
  margin: 0;
`

export const WizardIcon = styled(AutoFixHighIcon)`
  color: ${colors.interactive.primaryEnabled};
`

// Common layout items for each step

export const Container = styled('div')({
  display: 'flex',
  flexDirection: 'column',
  gap: '32px',
  width: '100%',
})

export const ActionContainer = styled('div')`
  display: flex;
  justify-content: flex-end;
  gap: 16px;
  margin-top: 8px;

  .MuiButton-text:hover {
    background: none !important;
  }
`

export const InputSection = styled(Box)``
